import { CommonModule, formatDate } from '@angular/common';
import { Component, inject, input, OnChanges, signal, SimpleChanges, viewChild } from '@angular/core';
import { ResumeReference } from 'src/app/models/resume/resume';
import { ResumeService } from 'src/app/services/resume.service';
import Swal from 'sweetalert2';
import { ModalReferenceComponent } from './modal-reference/modal-reference.component';
import { AddResumeReference } from 'src/app/models/resume/add-resume';
import { NgxMaskPipe } from 'ngx-mask';

@Component({
  selector: 'app-cv-references',
  imports: [ModalReferenceComponent, NgxMaskPipe],
  templateUrl: './cv-references.component.html',
  styleUrl: './cv-references.component.css'
})
export class CvReferencesComponent {
  public resumeId = input<number | null>(null);
  references = signal<ResumeReference[]>([]);

  private readonly resumeService = inject(ResumeService);

  indexResume = signal<number | null>(null);

  modalReferenceComponent = viewChild(ModalReferenceComponent);

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['resumeId']?.currentValue) {
      this.getResumereferences();
    }
  }

  getResumereferences() {
    const resumeId = this.resumeId();
    if (!resumeId) {
      return;
    }
    this.resumeService.getResumeReferences(resumeId).subscribe({
      next: res => {
        this.references.set(res);
      }
    });
  }

  add() {
    this.indexResume.set(null);
    if (this.modalReferenceComponent()) {
      this.modalReferenceComponent()?.reset();
    }
  }

  editResumeReference(resumeReference: ResumeReference, index: number) {
    this.indexResume.set(index);
    if (this.modalReferenceComponent()) {
      this.modalReferenceComponent()?.form.patchValue({
        ...resumeReference as any
      });
    }
  }

  deleteResumeReference(resumeReference: ResumeReference, index: number) {
    const resumeId = this.resumeId();
    const id = resumeReference.id ?? 0;

    if (!resumeId) {
      this.references.update(value => value?.filter((Reference, i) => i !== index));
      return;
    }

    Swal.fire({
      title: 'Eliminar',
      text: '¿Desea eliminar este registro?',
      icon: "question",
      showCancelButton: true,
      confirmButtonColor: '#0d1174',
      cancelButtonColor: '#3a3a3a',
      confirmButtonText: 'Eliminar'
    }).then((resultmodal) => {
      if (resultmodal.isConfirmed) {
        this.resumeService.deleteResumeReference(id).subscribe({
          next: res => {
            this.references.update(references => references.filter(Reference => Reference.id !== id));
          }, error: res => {
            Swal.fire({
              title: 'Error',
              text: 'Ocurrió un error al eliminar el registro.',
              icon: 'error',
              confirmButtonColor: '#d33'
            });
          }
        })
      }
    });
  }

  handlerResumeReference(resumeReference: AddResumeReference) {
    const resumeId = this.resumeId();
    if (resumeId) {
      this.getResumereferences();
      return;
    }
    if (this.indexResume() != null || resumeReference.id) {
      this.references.update(value => value?.map((Reference, i) => {
        if (i === this.indexResume() || Reference.id === resumeReference.id) {
          return resumeReference
        }
        return Reference;
      }));
      return;
    }
    this.references.set([...this.references(), resumeReference]);
  }
}
